import { IPayPeriod, IPayPeriodClosure, IPayPeriods, PayPeriodAction } from 'types';

export enum PayPeriods {
  GET_PAY_PERIODS_REQUEST = '@payperiods/GET_PAY_PERIODS_REQUEST',
  GET_PAY_PERIODS_SUCCESS = '@payperiods/GET_PAY_PERIODS_SUCCESS',
  GET_PAY_PERIODS_FAIL = '@payperiods/GET_PAY_PERIODS_FAIL',

  GET_PAY_PERIODS_BETWEEN_REQUEST = '@payperiods/GET_PAY_PERIODS_BETWEEN_REQUEST',
  GET_PAY_PERIODS_BETWEEN_SUCCESS = '@payperiods/GET_PAY_PERIODS_BETWEEN_SUCCESS',
  GET_PAY_PERIODS_BETWEEN_FAIL = '@payperiods/GET_PAY_PERIODS_BETWEEN_FAIL',

  UPDATE_PAY_PERIOD_STATUS_REQUEST = '@payperiods/UPDATE_PAY_PERIOD_STATUS_REQUEST',
  UPDATE_PAY_PERIOD_STATUS_SUCCESS = '@payperiods/UPDATE_PAY_PERIOD_STATUS_SUCCESS',
  UPDATE_PAY_PERIOD_STATUS_FAIL = '@payperiods/UPDATE_PAY_PERIOD_STATUS_FAIL',
}

export const PAY_PERIODS_PAGE_SIZE = 10;

// Store key for a site's periods.
export interface IPayPeriodsKey {
  siteId: string;
  orgId: string;
}

export interface IGetPayPeriodsPayload extends IPayPeriodsKey {
  // Cursor for the next page: the start of the oldest loaded period. Omit for the first page.
  before?: string;
  // Start of the selected period: loads every period from it to today instead of a page.
  from?: string;
}

export interface IGetPayPeriodsSuccessPayload extends IPayPeriodsKey {
  response: IPayPeriods;
}

// Every period overlapping start..end, YYYY-MM-DD.
export interface IGetPayPeriodsBetweenPayload {
  siteId: string;
  start: string;
  end: string;
  onSuccess: (payPeriods: IPayPeriod[]) => void;
}

// Closes or reopens a period.
export interface IUpdatePayPeriodStatusPayload extends IPayPeriodsKey {
  payPeriod: IPayPeriod;
  status: PayPeriodAction;
  // Runs once the request settles, with the closure on success.
  onComplete?: (closure?: IPayPeriodClosure) => void;
}

export interface IUpdatePayPeriodStatusSuccessPayload extends IPayPeriodsKey {
  response: IPayPeriodClosure;
}
